// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"e2cfdccf","173":"5ef9940e","532":"45094ed7"}[chunkId] + ".chunk.js";
};